import React, { useState } from 'react';
import Layout from './Layout';
import { motion } from 'framer-motion';
import { FaCopy } from 'react-icons/fa';


const AarticleExcel1SimpleMacros = () => {
  const [copiedStates, setCopiedStates] = useState({});

  const sections = [
    {
      id: 1,
      title: "Simple Excel Macros That Will Save You Time",
      text: `Hello, I am Lucas, and I hate repetitive work just as much as you. Therefor I dedicate a lot of my thinking time to how to do my current work tasks faster or completely automize them so I can free up time to do more exiciting tasks. Excel macros are powerful automation tools that can save hours of repetitive work. In this article, we will explore six simple yet effective macros that every Excel user should know to speed up common tasks working in finance. 
      However, first of all, I suggest, you, to create a personal tab to enable these macros across workbooks. This is done by going to File > Options > Customize Ribbon, then create a new tab and add your macros to it. This way, you can access them from any workbook. Now, let's dive into the macros!

1. Auto-Format Worksheet
This macro quickly formats your worksheet with consistent styling:
`,
      code: `Sub AutoFormatWorksheet()
    With ActiveSheet.UsedRange
        .Font.Name = "Arial"
        .Font.Size = 11
        .Borders.LineStyle = xlContinuous
        .Columns.AutoFit
    End With
End Sub`,
      explanation: "This macro applies consistent formatting across your worksheet, including font style, size, borders, and column width optimization. Now this is a simple example but you can easily customize it to fit your company colors to reduce manual formatting time and standardizing the look of the business on the inside which can be useful to help people be on the same page at all times.",
    },
    {
      id: 2,
      title: "Quick Data Clean-up Macro",
      text: `One of the most time-consuming tasks in Excel is cleaning up imported data. This macro helps remove common issues:`,
      code: `Sub CleanupData()
    Dim rng As Range
    Set rng = Selection
    With rng
        .Value = .Value
        .TextToColumns Destination:=.Cells(1), DataType:=xlDelimited
        .Cells.RemoveDuplicates
        .SpecialCells(xlCellTypeBlanks).Delete shift:=xlUp
    End With
End Sub`,
      explanation: "This macro converts formulas to values, splits text to columns, removes duplicates, and deletes blank cells - all in one click!",
    },
    {
      id: 3,
      title: "#N/A Error Check Macro",
      text: `One common issue in Excel is dealing with #N/A errors. This macro helps you quickly identify these errors in your worksheet:`,
      code: `Sub CheckForNAs()
    'Purpose: Check for #N/As in current sheet
    On Error GoTo err
        Cells.SpecialCells(xlCellTypeFormulas, xlErrors).Select
    Exit Sub
    err:
        If err.Number = 1004 Then MsgBox "No Errors Here!"
End Sub`,
      explanation: "This macro automatically selects all cells containing #N/A errors, making it easy to spot and fix issues in your formulas. If no errors are found, it displays a message."
    },
    {
      id: 4,
      title: "Formula Checker Macro",
      text: `Need to quickly identify which cells contain formulas? This macro highlights all formula cells in your worksheet:`,
      code: `Sub CheckForFormulas()
    'Purpose: Check for formulas in current sheet
    On Error GoTo err
        Cells.SpecialCells(xlCellTypeFormulas).Select
    Exit Sub
    err:
        If err.Number = 1004 Then MsgBox "No Formulas Here!"
End Sub`,
      explanation: "Perfect for auditing worksheets or understanding complex spreadsheets, this macro selects all cells containing formulas."
    },
    {
      id: 5,
      title: "External Formula Removal Macro",
      text: `Working with external references can be risky. This macro helps you convert external formulas to values, remember to enable Option Explicit:`,
      code: `Sub KillExternalFormulas()
    'Purpose: Replaces external formulas that link to other workbooks with their values
    'Only applies to cells in selection
    
    Dim replaced As Long
    Dim wholebook As VbMsgBoxResult
    Dim wholesheet As VbMsgBoxResult
    Dim cell As Range
    Dim Sheet As Worksheet
    
    replaced = 0
    
    wholebook = MsgBox("Do you want to Remove External Formulas from the whole WORKBOOK? Click no for active sheet or selection. You Can't Undo This!!", vbYesNoCancel + vbInformation, "Apply to whole WORKBOOK?")
    
    If wholebook = vbCancel Then Exit Sub
    
    If wholebook = vbNo Then
        wholesheet = MsgBox("Do you want to Remove External Formulas from the whole WORKSHEET? Click no if you just want to remove from the selection. You Can't Undo This!!", vbYesNoCancel, "Apply to whole WORKSHEET?")
        If wholesheet = vbCancel Then Exit Sub
        If wholesheet = vbYes Then ActiveSheet.UsedRange.Select
        For Each cell In Selection
            If InStr(cell.Formula, "!") > 0 Then
                cell.Value = cell.Value
                replaced = replaced + 1
            End If
        Next cell
    Else
        For Each Sheet In ActiveWorkbook.Worksheets
            For Each cell In Sheet.UsedRange
                If InStr(cell.Formula, "!") > 0 Then
                   cell.Value = cell.Value
                   replaced = replaced + 1
                End If
            Next cell
        Next Sheet
    End If
    
    MsgBox replaced & " formula(s) removed!"

End Sub`,
      explanation: "This advanced macro helps you remove external references by converting them to values. It gives you options to apply the changes to a selection, worksheet, or entire workbook.",
    },
    {
      id: 6,
      title: "Automated Email Report Distribution",
      text: `Streamline your reporting process by automatically emailing Excel files to your team or stakeholders. This macro connects Excel with Outlook to:

1. Create a new email
2. Add multiple recipients (perfect for distribution lists)
3. Include a professional message template
4. Automatically attach the current workbook
5. Save time on recurring report distributions

This is particularly useful for:
- Weekly financial updates to management
- Daily operational reports to team leaders
- Monthly KPI distributions to stakeholders
- Regular data updates to project teams`,
      code: `Sub SendWorkbookByEmail()
    'Set up error handling
    On Error Resume Next
    
    'Create Outlook objects
    Dim OutApp As Object
    Dim OutMail As Object
    Set OutApp = CreateObject("Outlook.Application")
    Set OutMail = OutApp.CreateItem(0)
    
    'Email template settings
    With OutMail
        .To = "team@company.com; management@company.com"
        .CC = "supervisor@company.com"
        .Subject = "Weekly Report - " & Format(Date, "dd-mm-yyyy")
        .Body = "Dear Team," & vbNewLine & vbNewLine & _
                "Please find attached the latest report." & vbNewLine & vbNewLine & _
                "Key updates:" & vbNewLine & _
                "- Updated figures for this week" & vbNewLine & _
                "- New projections added" & vbNewLine & vbNewLine & _
                "Best regards," & vbNewLine & _
                Application.UserName
                
        'Save and attach current workbook
        ThisWorkbook.Save
        .Attachments.Add ThisWorkbook.FullName
        
        'Display email for review before sending
        .Display
    End With
    
    'Cleanup
    Set OutMail = Nothing
    Set OutApp = Nothing
End Sub`,
      explanation: "This macro automates the tedious process of saving your workbook, creating an email, adding recipients, writing a message, and attaching the file. Simply customize the email template and recipient list to match your needs. You can also modify the subject line to include dynamic dates or report names, and adjust the message body to include specific report highlights or instructions."
    },
    {
      id: 7,
      title: "Implementing These Macros",
      text:`To implement these macros in your Excel workbook:

1. Press Alt + F11 to open the VBA editor
2. Insert a new module (Insert > Module) to put them in your current workbook. Alternatively, place them in VBAProject (Personal.xlsb) to access them from any workbook (suggested).
3. Copy and paste the specfic macro code you wish to use.
4. Save the workbook as .xlsm (macro-enabled) if you choose to put the macros in your current workbook.
5. Run the macro through the Developer tab or assign a shortcut.

Feel free to customize these macros to match your specific needs. For assistance or custom macro development, contact me at Villingerbl@gmail.com`,
    },
    

  ];

  const copyToClipboard = (code, id) => {
    navigator.clipboard.writeText(code);
    setCopiedStates({ ...copiedStates, [id]: true });
    setTimeout(() => {
      setCopiedStates(prev => ({ ...prev, [id]: false }));
    }, 2000);
  };

  // Update the scrollToSection function to account for header height
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  // Add this function at the top of your component, after the sections array
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div>
      <Layout />
      <div className="w-full min-h-screen bg-gradient-to-b from-white to-white text-black pt-20">
        <div className="max-w-screen-lg mx-auto p-4">
          <div className="mb-12 flex justify-center">
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm max-w-[600px] w-full">
              <h2 className="text-2xl font-bold mb-4 text-center">Table of Contents</h2>
              <div className="space-y-2">
                {sections.map(section => section.title && (
                  <div 
                    key={section.id} 
                    className="cursor-pointer hover:scale-110 transition-colors text-center"
                    
                    onClick={() => scrollToSection(`section-${section.id}`)}
                  >
                    {section.id}. {section.title}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="space-y-16">
            {sections.map(({ id, title, text, code, explanation }) => (
              <motion.div 
                key={id}
                id={`section-${id}`}  // Add this line
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
                className="flex flex-col gap-6"
              >
                <h2 className="text-3xl font-bold">{title}</h2>
                <div className="text-lg whitespace-pre-wrap">{text}</div>
                
                {code && (
                  <div className="relative">
                    <pre className="bg-gray-100 p-4 rounded-lg overflow-x-auto">
                      <code className="text-sm">{code}</code>
                    </pre>
                    <button
                      onClick={() => copyToClipboard(code, id)}
                      className="absolute top-2 right-2 p-2 bg-white rounded-md hover:bg-gray-200"
                    >
                      <FaCopy />
                      {copiedStates[id] && (
                        <span className="absolute -right-16 top-2 text-green-600">
                          Copied!
                        </span>
                      )}
                    </button>
                  </div>
                )}
                
                {explanation && (
                  <p className="text-gray-600 italic">{explanation}</p>
                )}
              </motion.div>
            ))}
          </div>
          {/* Back to Top Button */}
          <div className="flex justify-center mt-12 mb-8">
            <button
              onClick={scrollToTop}
              className=" text-white font-semibold py-2 px-4 rounded-lg shadow transition-colors duration-300 hover:scale-110" 
              style={{ background: 'rgb(1, 50, 32)' } }>
              Back to Top
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AarticleExcel1SimpleMacros;